<template>
  <v-card>
    <v-card-title class="headline">{{ text }}</v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="confirm(false)">
        {{ $t('common.no') }}
      </v-btn>
      <v-btn color="primary" text @click="confirm(true)">
        {{ $t('common.yes') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'confirm-modal',
  props: {
    text: String
  },
  methods: {
    confirm(value) {
      this.$emit('close', value);
    }
  }
};
</script>
